export { default as AnalyticsPlaceOfServiceTable } from './AnalyticsPlaceOfServiceTable';
